// File: frontend/src/models/enums/EntryTargetTypeEnum.ts

// Mirrors backend EntryTargetType.java. An entry has no stored "type" field —
// it belongs to exactly one of match / person / club / team / customTopic —
// this enum only exists to drive the admin panel's "Başlık Tipi" filter.
export enum EntryTargetTypeEnum {
  MATCH = "MATCH",               // Maç
  PERSON = "PERSON",             // Kişi
  CLUB = "CLUB",                 // Kulüp
  TEAM = "TEAM",                 // Takım
  CUSTOM_TOPIC = "CUSTOM_TOPIC",  // Gündem
}